// Themes
import PhotoCarousel from './PhotoCarousel';
import theme from '@/themes/index';

const MobilePhotoContainer = ({
  images,
  isDesktop, 
}) => (
  <>
    <div>
      <PhotoCarousel images={images} isDesktop={isDesktop} />
    </div>
    <style jsx>{`
      @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
        div {
          display: none;
        }
      }
    `}</style>
  </>
);

export default MobilePhotoContainer;
